<script lang="ts">
/**
 * @deprecated Please use `<TextInput />` or `<InputGroup><TextInput /></InputGroup>` instead.
 */
export default {};
</script>

<script setup lang="ts">
import { useForwardExpose } from "reka-ui";
import { computed, useAttrs } from "vue";
import {
	convertDeprecatedSize,
	removeDeprecatedSize,
	type DeprecatedSizeProps,
} from "../../lib/size";
import FormField from "../form/FormField.vue";
import InputGroup from "../inputgroup/InputGroup.vue";
import type { InputProps } from "./Input.vue";
import Input from "./Input.vue";

const props = defineProps<
	InputProps &
		DeprecatedSizeProps & {
			label?: string;
			errors?: string[];
		}
>();
defineOptions({ inheritAttrs: false });

const size = computed(() => {
	if (props.size != null) {
		return props.size;
	}

	return convertDeprecatedSize(props) || undefined;
});

const model = defineModel<any>();

const { forwardRef } = useForwardExpose();

function attrsClassExtractor(attrs: Readonly<Record<string, unknown>>) {
	const copy = { ...attrs };
	const _class = copy.class as string;
	delete copy.class;

	return {
		class: _class || "",
		attrs: copy,
	};
}

const attrs = useAttrs();
const attributes = computed(() => {
	return attrsClassExtractor(attrs);
});
</script>

<template>
	<FormField class="w-full" :label="props.label" :errors="props.errors">
		<InputGroup :class="{ 'z-1 w-full!': true, [attributes.class]: true }">
			<slot name="prepend" />

			<Input
				:ref="forwardRef"
				v-model="model"
				class="w-full"
				v-bind="{ ...removeDeprecatedSize(props), size, ...attributes.attrs }"
			/>

			<slot name="append" />
		</InputGroup>
	</FormField>
</template>
